import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const headerSection = css`
  border-start-end-radius: 0;
  border-start-start-radius: 0;
  margin-block-end: ${spacing(0.25)};
`

export const bodySection = css`
  margin-block-end: ${spacing(0.25)};
  padding: ${spacing(1, 2)};
`

export const bodySectionSquareTop = css`
  border-start-start-radius: 0;
  border-start-end-radius: 0;
`

export const bottomSectionWrapper = css`
  background-color: ${cssTheme.colors.absolute.white};
  border-start-start-radius: ${spacing(3)};
  border-start-end-radius: ${spacing(3)};
  overflow: hidden;
`
